import React from 'react'

export default (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <g fill="none" fillRule="evenodd" transform="rotate(90 16 16)">
            <rect width="32" height="32" fill="#415DD4" rx="16"/>
            <path fill="#FFF" d="M8.727 13.09h14.546v1.455H8.727v-1.454zm0 4.365h14.546v1.454H8.727v-1.454z"/>
        </g>
    </svg>
)
